document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-drop-hint-modal]');
  const openBtn = document.querySelector('[data-drop-hint-open]');
  const closeBtns = document.querySelectorAll('[data-drop-hint-close]');
  const form = document.querySelector('[data-drop-hint-form]');
  const formState = document.querySelector('[data-drop-hint-form-state]');
  const successState = document.querySelector('[data-drop-hint-success-state]');
  const modalImage = document.querySelector('[data-drop-hint-product-image]');
  const imageInput = document.querySelector('[data-drop-hint-image-input]');
  const variantIdInput = document.querySelector('[data-drop-hint-variant-id]');
  const errorBox = document.querySelector('[data-drop-hint-error]');
  const variantJsonScript = document.querySelector('#DropHintVariantJson');

  if (!modal || !openBtn || !form) return;

  let submittedOnce = false;
  let isSubmitting = false;
  const variants = variantJsonScript ? JSON.parse(variantJsonScript.textContent) : [];

  const previewRecipient = document.querySelector('[data-preview-recipient]');
const previewSender = document.querySelector('[data-preview-sender]');
const previewMessage = document.querySelector('[data-preview-message]');
const messageField = document.querySelector('textarea[name="message"]');
const countEl = document.querySelector('[data-drop-hint-count]');

if (form) {
  form.addEventListener('input', () => {
    const data = new FormData(form);

    if (previewRecipient) {
      previewRecipient.textContent = data.get('recipient_name') || '______';
    }

    if (previewSender) {
      previewSender.textContent = data.get('sender_name') || '______';
    }

    if (previewMessage) {
      previewMessage.textContent = data.get('message') || '';
    }

    if (messageField && countEl) {
      countEl.textContent = messageField.value.length;
    }
  });
}

  function getCurrentVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? Number(input.value) : null;
  }

  function getCurrentVariant() {
    const variantId = getCurrentVariantId();
    return variants.find(variant => variant.id === variantId) || null;
  }

  function getCurrentGalleryImage() {
    const activeImage =
      document.querySelector('.product__media-item.is-active img') ||
      document.querySelector('.product-media-wrapper img') ||
      document.querySelector('.product__media img');

    if (!activeImage) return null;

    return {
      src: activeImage.currentSrc || activeImage.src,
      alt: activeImage.alt || ''
    };
  }

  function syncModalImage() {
    const currentVariant = getCurrentVariant();

    if (currentVariant && variantIdInput) {
      variantIdInput.value = currentVariant.id;
    }

    if (currentVariant && currentVariant.featured_image) {
      const src = currentVariant.featured_image.src;
      modalImage.src = src;
      modalImage.alt = currentVariant.name || '';
      if (imageInput) imageInput.value = src;
      return;
    }

    const galleryImage = getCurrentGalleryImage();
    if (galleryImage) {
      modalImage.src = galleryImage.src;
      modalImage.alt = galleryImage.alt;
      if (imageInput) imageInput.value = galleryImage.src;
    }
  }

  function openModal() {
    syncModalImage();
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');

    if (submittedOnce) {
      formState.classList.add('hidden');
      successState.classList.remove('hidden');
    } else {
      formState.classList.remove('hidden');
      successState.classList.add('hidden');
    }

    document.body.classList.add('overflow-hidden');
  }

  function closeModal() {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  openBtn.addEventListener('click', openModal);
  closeBtns.forEach(btn => btn.addEventListener('click', closeModal));

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('input[name="id"]') ||
      event.target.matches('input[name^="options"]') ||
      event.target.matches('select[name^="options"]')
    ) {
      syncModalImage();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (submittedOnce) {
      formState.classList.add('hidden');
      successState.classList.remove('hidden');
      return;
    }

    if (isSubmitting) return;
    isSubmitting = true;

    try {
      const formData = new FormData(form);

      const response = await fetch('/apps/drop-a-hint', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Submit failed');

      submittedOnce = true;
      formState.classList.add('hidden');
      successState.classList.remove('hidden');
    } catch (error) {
      if (errorBox) {
        errorBox.textContent = 'Something went wrong. Please try again.';
        errorBox.classList.remove('hidden');
      }
    } finally {
      isSubmitting = false;
    }
  });
});